export default __webpack_public_path__ + "static/wiss-6fa6145ea360fedf9985340c24c31ca9.pdf";